import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Add from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import { FieldArray } from 'react-final-form-arrays';
import InternalSuppressionItem from './InternalSuppressionItem';
import { SelectField } from '../../FinalForm';

const generateName = (field, source) => {
  return source ? `${source}.${field}` : field;
};

const renderInternalPrePings = (source) => {
  return (
    <FieldArray name={generateName('internalPrePingConfiguration.internalPrePings', source)}>
      {({ fields }) => {
        return fields.map((fieldName, index) => {
          return (
            <div key={index}>
              <Card>
                <CardHeader
                  slotProps={{ title: { component: 'div' } }}
                  title={
                    fields.length > 1 ? (
                      <Tooltip title='Remove Internal Pre Ping'>
                        <IconButton
                          color='error'
                          type='button'
                          aria-label='Remove Internal Pre Ping'
                          onClick={() => fields.remove(index)}
                        >
                          <Close fontSize='small' />
                        </IconButton>
                      </Tooltip>
                    ) : null
                  }
                />
                <CardContent>
                  <InternalSuppressionItem name={fieldName} source={source} fields={fields} />
                </CardContent>
              </Card>
              {index === fields.length - 1 && (
                <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                  <Grid size={{ xs: 12, lg: 2 }} offset={{ lg: 10 }}>
                    <Tooltip title='Add Internal Pre Ping'>
                      <IconButton color='success' aria-label='Add Internal Pre Ping' onClick={() => fields.push({})}>
                        <Add />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )}
            </div>
          );
        });
      }}
    </FieldArray>
  );
};

export const InternalPrePings = ({ shouldRenderSuppression, source }) => {
  return (
    <>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <SelectField
            name={generateName('internalPrePingConfiguration.andOrLogic', source)}
            options={[
              {
                value: 'AND',
                option: 'All entries must pass',
              },
              {
                value: 'OR',
                option: 'Any of these entries can pass',
              },
            ]}
          />
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size={12} sx={{ height: 400, overflowY: 'auto' }}>
          {renderInternalPrePings(source)}
        </Grid>
      </Grid>
    </>
  );
};

export default InternalPrePings;
